import React from "react";
import PropTypes from "prop-types";

import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import EditIcon from "@mui/icons-material/Edit";


const AttributeList = (props) => {

    const {attributes, appendFormComponents=true} = props;

    return <>
        <List>
            {
                attributes.map(({label, value, defaultValue, icon, readOnly, formDialog, onClick}, i) => (
                    <div key={i}>
                        <ListItem disablePadding>
                            <ListItemButton dense
                                            disabled={!!readOnly}
                                            onClick={onClick ?? formDialog?.open}>
                                {icon && <ListItemIcon>{icon}</ListItemIcon>}
                                <ListItemText primary={(typeof value !== 'undefined' && value !== null && value !== "") ? value : defaultValue}
                                              secondary={label}
                                              primaryTypographyProps={{whiteSpace: "pre-wrap"}}/>
                                {!readOnly && <EditIcon fontSize="small"/>}
                            </ListItemButton>
                        </ListItem>
                        {i !== attributes.length - 1 && <Divider variant="inset"/>}
                    </div>
                ))
            }
        </List>

        { appendFormComponents && <AttributeListFormComponents attributes={attributes}/>}
    </>
}


export const AttributeListFormComponents = ({attributes}) => {
    return <>
        {
            attributes.filter(({readOnly}) => !readOnly)
                .map(({formDialog, formComponent}, i) => (
                    <React.Fragment key={i}>
                        {
                            formDialog.show && formComponent
                        }
                    </React.Fragment>
                ))
        }
    </>
}

AttributeList.propTypes = {
    /*
     * Each attribute object should have the following attributes:
     * - label: the name of the attribute to be displayed
     * - value: the value of the attribute to be displayed
     * - defaultValue: the default value of the attribute
     * - icon: the icon component
     * - readOnly (default false)
     * - onClick (default open the form dialog)
     *
     * If readOnly is false then it should also have:
     * - formDialog: a useDialog hook
     * - formComponent: the form component to modify the attribute (which show and loading state is handled by formDialog)
     */
    attributes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AttributeList;